import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';
import moment from 'moment';

@Component({
    name: 'statistic-line-graph',
})

export default class StatisticLineGraph extends Vue {

    // -----------------------------------------------------------------------
    // Properties

    @Prop({default: 70})
    private width!: number;

    @Prop({default: 60})
    private height!: number;

    private margin: any = {top: 2, right: 2, bottom: 5, left: 5};

    @Prop()
    private lineData!: any;

    @Watch('lineData')
    private onWatchData(value: any) {
        this.drawLineChart();
    }


    // -------------------------------------------------------------------------
    // Hooks

    private mounted() {
        this.drawLineChart();
    }


    // -------------------------------------------------------------------------
    // Methods

    private drawLineChart() {
        const margin = this.margin;
        const width = this.width;
        const height = this.height;
        const lineData = this.lineData;
        d3.select(this.$el).select('svg').remove();
        const svgContainer = d3.select(this.$el)
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        const xScale: any = d3.scaleTime().domain(d3.extent(lineData, (d: any) => {
            return new Date(d.date);
        }) as any).range([0, width]);

        const yScale: any = d3.scaleLinear()
            .domain([0, d3.max(lineData, (d: any) => d.count) as any])
            .range([height, 0]);

        const lineChart = d3.line()
            .x((d: any) => xScale(new Date(d.date)))
            .y((d: any) => yScale(d.count));

        svgContainer.append('path')
            .attr('class', 'line-chart')
            .datum(lineData)
            .attr('d', lineChart);

        svgContainer.append('g')
            .attr('class', 'c-points')
            .selectAll('dot')
            .data(lineData)
            .enter()
            .append('circle')
            .attr('cx', (d: any) => xScale(new Date(d.date)))
            .attr('cy', (d: any) => yScale(d.count))
            .on('mouseenter', (d: any) => {
                const mountEvent = d3.event;
                const labelPos = (mountEvent.offsetY > (height / 2)) ? 10 : height - 10;
                verticalLine.attr('x1', xScale(new Date(d.date)));
                verticalLine.attr('x2', xScale(new Date(d.date)));
                verticalLine.classed('hide-line-bar', false);
                textContainer.attr('x', xScale(new Date(d.date)) - 15)
                    .attr('y', labelPos)
                    .text(() => {
                        return `${d.count}`;
                    })
                    .classed('hide-text-panel', false);
            })
            .on('mouseleave', () => {
                verticalLine.classed('hide-line-bar', true);
                textContainer.classed('hide-text-panel', true);
            })
            .attr('r', 3);

        const verticalLine = svgContainer.append('g')
            .attr('class', 'vertical-line')
            .append('line')
            .attr('class', 'hide-line-bar')
            .attr('x1', 0)
            .attr('y1', 0)
            .attr('x2', 0)
            .attr('y2', height);

        const textContainer = svgContainer.append('text')
            .attr('class', 'text-panel hide-text-panel')
            .attr('x', 0)
            .attr('y', 10);

    }

}
